module.exports = {"id":"229321","name":"Amilton","rating":"72","photo":"./data/images/photos/3/229321.png","club":{"name":"CD Aves","logo":"./data/images/clubs/CDAves.png"},"positions":["AD","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Amilton0.json
// module id = 314
// module chunks = 0